import type { Requester } from '@labeling/globals';

export const isAdmin = (user: Requester): boolean => user.type === 'admin';

export const isAdminOrMaintainer = (user: Requester): boolean =>
  isAdmin(user) || user.type === 'maintainer';

export const isOperator = (user: Requester): boolean => user.type === 'operator';

export const canManageOperatorAccess = (user: Requester): boolean =>
  isAdminOrMaintainer(user) || (user.type === 'user' && user.applications.length > 0);

export const canEditPrinterAssignments = (user: Requester): boolean => {
  return isAdminOrMaintainer(user);
};

export const canEditPrinterInfo = (user: Requester): boolean => {
  return isAdminOrMaintainer(user);
};

export const canEditPrinterLocation = (user: Requester): boolean => {
  return isAdmin(user);
};

/**
 * Workcenter ID and printer position are editable by everyone except operators.
 * Mirrors the API, where `PUT /v1/printers/:id` resolves the scope via
 * `getAvailableApplications` (which 403s operators). Note that for a plain
 * `user` the API additionally restricts writes to printers assigned to their
 * own applications — the UI cannot know that up front, so a save may still be
 * rejected with a 403 that surfaces as a toast.
 */
export const canEditPrinterWorkcenter = (user: Requester): boolean => {
  return !isOperator(user);
};

export const canEditLabelAssignments = (user: Requester): boolean => {
  return isAdminOrMaintainer(user);
};

export const canEditLocationInfo = (user: Requester): boolean => {
  return isAdmin(user);
};

export const canCreateLocation = (user: Requester): boolean => {
  return isAdmin(user);
};

export const canDeleteLocation = (user: Requester): boolean => {
  return isAdmin(user);
};

export const canEditForms = (user: Requester): boolean => {
  return !isOperator(user);
};
